import styled from "styled-components";
import React from "react";
import { Label } from "../../atoms";
import { Input } from "../../atoms";
import { Icon } from "../../atoms";

export interface InputWithWildCardProps {
  /**
   * What is the input type
   */
  type: "text" | "password" | "tel" | "number" | "email";
  /**
   * What is the input Mode
   */
  inputMode?:
    | "text"
    | "decimal"
    | "numeric"
    | "search"
    | "email"
    | "tel"
    | "url"
    | "none";
  /**
   * What is the input default placeholder
   */
  placeholder: string;
  /**
   * What action should be done one input change ?
   */
  handleOnChange: (e: any) => void;
  /**
   * What is input label ?
   */
  lbl?: string;
  /**
   * What is span wild card ?
   */
  wild?: string;
  /**
   * What is wild color?
   */
  wildColor?: string;
  /**
   * What is Card Bg?
   */
  bgColor?: string;
  /**
   * What is Input Default Value?
   */
  defaultValue?: any;
  /**
   * What is Input Default name?
   */
  name?: string;
  /**
   * What is Input Default Direction?
   */
  direction?: string;
  readonly?: boolean;
  maskType?:
    | "DEFAULT"
    | "MASKED"
    | "CARD"
    | "IBAN"
    | "VERIFICATION"
    | "FIVEDIGIT";
  /**
   * Masked Listen To Change?
   */
  listenToChange?: boolean;
  hasError?: boolean;
  height?: string;
  icon?: string;
  maxLength?: number;
  hasDisabled?: boolean;
}
/**
 * Styled Form Group
 */

interface InputHolderProps {
  color: string;
  theme: any;
  hasError?: boolean;
  height: string;
}
const FormGroup = styled.div`
  width: 100%;
  margin-bottom: 12px;
`;

/**
 * Styled Input Div Holder
 */
const WildCardSpan = styled.span.attrs((props) => {
  const color = props.color ? props.theme[props.color] : "Light5";
  return {
    style: {
      color: `${color}`,
    },
  };
})`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 60px;
  direction: ltr;
  font-size: 14px;
`;

const InputHolder = styled.div<InputHolderProps>`
  display: flex;
  height: ${(p) => p.height};
  border-radius: 8px;
  background-color: ${(p) => (theme) => theme.theme[p.color]};
  border: ${(p) => (p.hasError ? "1px solid #F84960" : "none")};
`;

/**
 *  ================== MAIN FC ===============
 */
export const InputWithWildCard: React.FC<InputWithWildCardProps> = ({
  type,
  inputMode = "tel",
  placeholder,
  lbl,
  name = "",
  wild = "Not Set",
  handleOnChange,
  bgColor = "bgButton",
  wildColor = "bgText",
  defaultValue,
  direction,
  readonly = false,
  maskType,
  listenToChange = false,
  hasError = false,
  icon = undefined,
  height = "48px",
  maxLength = 1000,
  hasDisabled = false,
}) => {
  return (
    <FormGroup>
      {lbl && <Label lbl={lbl} />}
      <InputHolder color={bgColor} hasError={hasError} height={height}>
        <Input
          listenToChange={listenToChange}
          inputMode={inputMode}
          maskType={maskType}
          type={type}
          defaultValue={defaultValue}
          placeholder={placeholder}
          handleOnChange={handleOnChange}
          name={name}
          direction={direction}
          readonly={readonly}
          hasError={hasError}
          maxLength={maxLength}
          hasDisabled={hasDisabled}
        />
        {wild && (
          <WildCardSpan color={wildColor}>
            {icon ? <Icon name={icon} width="18px" height="18px" /> : wild}
          </WildCardSpan>
        )}
      </InputHolder>
    </FormGroup>
  );
};
